<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="border-0">Lojas</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in representatives" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <a @click.stop="edit(row)" >{{ row.name }}</a>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="td-2">{{ row.count_resellers }}</td>
        <td class="td-2">
          <representative-buttons :representative="row"></representative-buttons>
        </td>
      </tr>
      <tr v-if="representatives.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum representante cadastrado.</td>
      </tr>
    </tbody>
    <representative-imports/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import RepresentativeButtons from './RepresentativeButtons.vue';
import RepresentativeImports from './RepresentativeImports.vue';
import { _EDIT_REPRESENTATIVE_ } from './RepresentativeModel';

export default {
  name: 'representative-table',
  components: {
    RepresentativeButtons,
    RepresentativeImports,
  },
  props: {
    representatives: {
      type: Array,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    edit(row) {
      this.setToggle({ type: 'edit_representative_modal', bool: true });
      Events.$emit(_EDIT_REPRESENTATIVE_, row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
